<div class="d-flex flex-column min-vh-100">
    <app-header [navbarBrandRouterLink]="['/user-panel/home']" [fixed]="true" [asideMenuToggler]="false" [mobileAsideMenuToggler]="false" [navbarBrandFull]="{src: 'assets/img/logo/eReturn_Logo.svg', width: 200, height: 40, alt: 'e-Return Logo'}" [navbarBrandMinimized]="{src: 'assets/img/logo/ereturn_short.png', width: 200, height: 40, alt: 'e-Return Logo'}"
        [sidebarToggler]="'lg'">

        <ul class="nav navbar-nav ml-auto">
            <li class="nav-item dropdown d-flex align-items-center" dropdown placement="bottom right">        
                <span class="mr-2">Assessment Year </span>
                <select class="form-control mr-5" style="width: 150px;" [(ngModel)]="currentAssessmentYear" (ngModelChange)="onChangeAssessmentYear($event, changeAssessmentYear)" aria-placeholder="Assessment Year">
                    <option *ngFor="let year of assessmentYearList" [value]="year.year">
                        {{year.year}}
                    </option>
                </select>

                <a class="nav-link d-flex align-items-center" title="account" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false" dropdownToggle (click)="false">
                    <span class="hidden-xs mr-1">{{taxpayerName}}</span>
                    <img *ngIf="hasImage" [src]="taxpayerProfileImg" class="rounded-circle img-100" alt="User Image" />
                    <img *ngIf="!hasImage" src="assets\img\background\default_profile.png" class="rounded-circle img-100" alt="User Image" />
                </a>
                <div class="dropdown-menu dropdown-menu-right " *dropdownMenu aria-labelledby="simple-dropdown">
                    <li class="user-header">
                        <img *ngIf="hasImage" [src]="taxpayerProfileImg" class="rounded-circle center img-50" alt="User Image">
                        <img *ngIf="!hasImage" src="assets\img\background\default_profile.png" class="rounded-circle center img-50" alt="User Image">
                        <div class="col-12 text-center">
                            <p class="m-0 font-weight-bold colorStyle">{{taxpayerName}}</p>
                            <p class="m-0 font-weight-bold colorStyle">TIN: {{taxpayerTIN}}</p>
                        </div>
                    </li>
                    <hr>
                    <a class="dropdown-item" [routerLink]="['/user-panel/taxpayer-profile']"><i class="fa fa-user"
              aria-hidden="true"></i>Profile</a>
                    <a class="dropdown-item" [routerLink]="['/user-panel/change-password']"><i class="fa fa-key"
              aria-hidden="true"></i>Change Password</a>
                    <a class="dropdown-item" [routerLink]="[]" (click)="logOut()"><i class="fa fa-sign-out"
              aria-hidden="true"></i>Logout</a>
                    <!-- <a class="dropdown-item" (click)="logOut()" [routerLink]="['/landing-page']"><i class="fa fa-sign-out"
              aria-hidden="true"></i>Logout</a>               -->
                </div>
            </li>
        </ul>

    </app-header>
    <div class="app-body">
        <app-sidebar #appSidebar [fixed]="true" [display]="'lg'" [minimized]="sidebarMinimized" (minimizedChange)="toggleMinimize($event)">
            <app-sidebar-nav [navItems]="navItems"></app-sidebar-nav>
            <app-sidebar-minimizer></app-sidebar-minimizer>
        </app-sidebar>
        <!-- Main content -->
        <main class="main" [class.main-with-maintenance]="showMaintenanceSection">
            <div
                #maintenanceSection
                *ngIf="showMaintenanceSection"
                class="maintenance-banner"
                [class.maintenance-pre]="maintenancePhase === 'pre-maintenance'"
                [class.maintenance-during]="maintenancePhase === 'during-maintenance'"
            >
                <div class="maintenance-banner-content">
                    <div class="maintenance-banner-left">
                        <i class="fa fa-exclamation-triangle maintenance-icon" aria-hidden="true"></i>
                        <div class="maintenance-text">
                            <p class="maintenance-heading" *ngIf="maintenancePhase === 'pre-maintenance'">
                                Return submission will be unavailable shortly
                            </p>
                            <p class="maintenance-heading" *ngIf="maintenancePhase === 'during-maintenance'">
                                Return submission will resume shortly.
                            </p>
                            <p class="maintenance-subtext">
                                Return submission will be paused from <b>1 October, 12:00 AM to 12:30 AM</b>.
                                The service will resume after <b>1 October, 12:30 AM</b>.
                                <br>
                                Please submit your return before this time to avail 1st Quarter Incentive.
                            </p>
                        </div>
                    </div>
                    <div class="maintenance-timer-badge">
                        <span *ngIf="maintenancePhase === 'pre-maintenance'">
                            Return submission will be unavailable in : <strong>{{ maintenanceCountdown }}</strong>
                        </span>
                        <span *ngIf="maintenancePhase === 'during-maintenance'">
                            Return submission resumes in : <strong>{{ maintenanceCountdown }}</strong>
                        </span>
                    </div>
                </div>
            </div>
            <div class="main-scroll-area" [class.has-maintenance-banner]="showMaintenanceSection">
                <div class="container-fluid">
                    <router-outlet></router-outlet>
                </div>
            </div>
        </main>
        <app-aside [fixed]="true" [display]="false">
        </app-aside>
    </div>
    <app-custom-footer></app-custom-footer>
</div>

<ng-template #changeAssessmentYear>
    <div class="modal-header">
        <h4 class="modal-title pull-left" style="color: orange; font-size: 14px; font-weight: bold;">Warning</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="cancelChangeAssessmentYear()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <p>This action will change the Assessment Year to <b>{{currentAssessmentYear}}</b>.
        </p>
        <p>Still want to change?</p>
        <button type="button" class="btn btn-danger" style="float: right;" (click)="changeAssessmentYearFn()">Change</button>
        <button type="button" class="btn btn-success" style="float: right; margin-right: 10px;"
            (click)="cancelChangeAssessmentYear()">Cancel</button>
    </div>
</ng-template>